import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Message } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DisplayMessage } from '../../core/messages/display-message';
import { DashboardData } from '../../viewmodels/dashboard-data';
import { DashboardWidget } from '../../viewmodels/dashboard/dashboard-widget';
import { WidgetSize } from '../../views/dashboard/widgets/widget-size';
import { DashboardService } from './dashboard.service';
import { AddWidgetDialogComponent } from './widgets/add-widget/add-widget-dialog.component';
import { WidgetDataType } from './widgets/widget-data-type';
import { WidgetDisplayType } from './widgets/widget-display-type.enum';
import { WidgetSettings } from './widgets/widget-settings';


@Component({
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  public widgetDataType = WidgetDataType;
  public widgetDisplayType = WidgetDisplayType;
  public widgetSize = WidgetSize;
  private unsub = new Subject<boolean>();
  public isTrue: boolean = true;

  messages: Message[] = [];

  public dashboardWidgets: DashboardWidget[] = new Array<DashboardWidget>();
  public widgetsSettings: WidgetSettings[] = [];

  constructor(public dashboardService: DashboardService, public bsModalRef: BsModalRef, public modalService: BsModalService, public authService: AuthService) { }

  public initialiseLiveData(data: DashboardData): void {
    this.dashboardService.dashboardId = data.dashboardId;
  }

  public get catalog(): string {
    return this.authService.urlCatalog;
  }

  public addWidget(): void {
    this.bsModalRef = this.modalService.show(AddWidgetDialogComponent);
  }

  public ngOnInit(): void {
    this.dashboardService.dataInitialised.pipe(takeUntil(this.unsub)).subscribe(data => {
      this.initialiseLiveData(data);
      this.setDashBoardWidgets(data.dashboardWidgets);
    });

    this.dashboardService.errors.pipe(takeUntil(this.unsub)).subscribe(errorResult => {
      errorResult.messages.forEach(message =>
        this.messages.push(new DisplayMessage('Could not retrieve dashboard data', message.text, message.severity)),
      );
    });
    this.dashboardService.initialiseDashboardData();

    this.dashboardService.widgetsUpdated.pipe(takeUntil(this.unsub)).subscribe(widgets => {
      this.setDashBoardWidgets(widgets);
    });
  }

  public ngOnDestroy(): void {
    this.unsub.next(true);
    this.unsub.complete();
  }

  private setDashBoardWidgets(dashboardWidgets: DashboardWidget[]): void {
    this.dashboardWidgets = dashboardWidgets;
    this.widgetsSettings = this.dashboardService.getWidgetsSettings(dashboardWidgets);
  }

}
